import { render, staticRenderFns } from "./side-navbar-component.vue?vue&type=template&id=25bff75b&scoped=true"
import script from "./side-navbar-component.vue?vue&type=script&lang=ts&setup=true"
export * from "./side-navbar-component.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./side-navbar-component.vue?vue&type=style&index=0&id=25bff75b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bff75b",
  null
  
)

export default component.exports